import React, { useEffect, useState } from 'react';
import { categoryService } from '../services/api';

// Modal reutilizável para gerenciar categorias (kind = 'product' | 'device' | 'game').
// onChange é chamado após qualquer alteração para o pai recarregar sua lista.
export default function CategoryManager({ kind, title, onClose, onChange }) {
  const [items, setItems] = useState([]);
  const [name, setName] = useState('');
  const [customerVisible, setCustomerVisible] = useState(true);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    const r = await categoryService.getAll(kind);
    setItems(r.data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [kind]);

  const notify = () => { load(); onChange && onChange(); };

  const add = async () => {
    if (!name.trim()) return;
    setLoading(true);
    try {
      await categoryService.create({
        kind,
        name: name.trim(),
        sort_order: items.length + 1,
        is_customer_visible: kind === 'product' ? customerVisible : true,
      });
      setName('');
      setCustomerVisible(true);
      notify();
    }
    catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  };
  const saveEdit = async () => {
    if (!editing.name.trim()) return;
    setLoading(true);
    try {
      await categoryService.update(editing.id, {
        name: editing.name.trim(),
        sort_order: editing.sort_order,
        is_customer_visible: kind === 'product' ? editing.is_customer_visible : true,
      });
      setEditing(null);
      notify();
    }
    catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  };
  const remove = async (c) => {
    if (!window.confirm(`Remover "${c.name}"? Os itens ficam sem categoria.`)) return;
    await categoryService.delete(c.id); notify();
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>{title}</h2>

        <div style={styles.addRow}>
          <input style={styles.input} placeholder="Nova categoria" value={name}
            onChange={e => setName(e.target.value)} onKeyDown={e => e.key === 'Enter' && add()} />
          <button style={styles.btnAdd} onClick={add} disabled={loading}>Adicionar</button>
        </div>
        {kind === 'product' && (
          <label style={styles.visibilityControl}>
            <input type="checkbox" checked={customerVisible}
              onChange={e => setCustomerVisible(e.target.checked)} />
            <span>Mostrar para o jogador</span>
          </label>
        )}

        <div style={styles.list}>
          {items.map(c => (
            <div key={c.id} style={styles.item}>
              {editing?.id === c.id ? (
                <>
                  <input style={styles.inputInline} value={editing.name}
                    onChange={e => setEditing({ ...editing, name: e.target.value })}
                    onKeyDown={e => e.key === 'Enter' && saveEdit()} autoFocus />
                  {kind === 'product' && (
                    <label style={styles.inlineVisibility} title="Mostrar esta categoria no Arena Desktop e no portal do jogador">
                      <input type="checkbox" checked={editing.is_customer_visible}
                        onChange={e => setEditing({ ...editing, is_customer_visible: e.target.checked })} />
                      jogador
                    </label>
                  )}
                  <button style={styles.link} onClick={saveEdit}>salvar</button>
                  <button style={styles.link} onClick={() => setEditing(null)}>cancelar</button>
                </>
              ) : (
                <>
                  <span style={styles.itemName}>{c.name}</span>
                  {kind === 'product' && (
                    <span style={c.is_customer_visible ? styles.visibleBadge : styles.controllerBadge}>
                      {c.is_customer_visible ? 'JOGADOR' : 'SÓ CONTROLLER'}
                    </span>
                  )}
                  <button style={styles.link} onClick={() => setEditing({
                    id: c.id,
                    name: c.name,
                    sort_order: c.sort_order,
                    is_customer_visible: Boolean(c.is_customer_visible),
                  })}>editar</button>
                  <button style={styles.linkDanger} onClick={() => remove(c)}>remover</button>
                </>
              )}
            </div>
          ))}
          {!items.length && <div style={styles.empty}>Nenhuma categoria ainda.</div>}
        </div>

        <div style={styles.actions}>
          <button style={styles.btnClose} onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 60, padding: 16 },
  modal: { background: '#14141f', border: '1px solid #262636', borderRadius: 16, padding: 26, width: 420, maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', overflowX: 'hidden', boxSizing: 'border-box' },
  title: { color: '#fff', fontSize: 19, fontWeight: 700, margin: '0 0 18px' },
  addRow: { display: 'flex', gap: 8, marginBottom: 16 },
  visibilityControl: { display: 'flex', alignItems: 'center', gap: 8, color: '#d1d5db', fontSize: 13, margin: '-8px 0 16px', cursor: 'pointer' },
  input: { flex: 1, padding: '10px 12px', background: '#262636', border: '1px solid #374151', borderRadius: 8, color: '#fff', fontSize: 14 },
  inputInline: { flex: 1, padding: '6px 10px', background: '#262636', border: '1px solid var(--accent)', borderRadius: 6, color: '#fff', fontSize: 14 },
  btnAdd: { padding: '10px 16px', background: 'var(--accent)', color: '#0a0a0f', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 },
  list: { display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 18 },
  item: { display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', background: '#0a0a0f', border: '1px solid #262636', borderRadius: 8 },
  itemName: { flex: 1, color: '#e5e7eb', fontSize: 14 },
  inlineVisibility: { display: 'flex', alignItems: 'center', gap: 4, color: '#d1d5db', fontSize: 11, whiteSpace: 'nowrap', cursor: 'pointer' },
  visibleBadge: { color: '#a3e635', background: '#1f330d', border: '1px solid #365314', borderRadius: 999, padding: '3px 7px', fontSize: 9, fontWeight: 800, whiteSpace: 'nowrap' },
  controllerBadge: { color: '#fbbf24', background: '#33260b', border: '1px solid #78350f', borderRadius: 999, padding: '3px 7px', fontSize: 9, fontWeight: 800, whiteSpace: 'nowrap' },
  link: { background: 'transparent', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: 13 },
  linkDanger: { background: 'transparent', border: 'none', color: '#f87171', cursor: 'pointer', fontSize: 13 },
  empty: { color: '#6b7280', fontSize: 13, padding: 8 },
  actions: { display: 'flex', justifyContent: 'flex-end' },
  btnClose: { padding: '9px 18px', background: 'transparent', border: '1px solid #374151', borderRadius: 8, color: '#9ca3af', cursor: 'pointer', fontSize: 14 },
};
